import { Link, LinkProps } from '@mui/material';
import React from 'react';

const LinkWrapper: React.FC<LinkProps> = ({ ...props }) => (
 
  <Link {...props} />
);

export default LinkWrapper;